 
import actionType from "./actionTypes";
import axios from "axios";
import { toast } from "react-toastify";
import { hideIsLoading, showIsLoading, refreshApiService,emailValidService } from "../common/action";
import { getRecordReqList, getNewFacilityList } from "../employee/action";
import URL from "../../assets/config";

export const getEmployeList = token => dispatch => {
 
  toast.dismiss();

  dispatch(showIsLoading());

  const config = {
    method: 'get',
    url: URL.admin.GET_EMPLOYE_LIST,
    headers: {
      'Content-Type' : "application/json",
       "Authorization": 'bearer  ' + token,
    }  
   };
  axios(config).then((res) => {
    dispatch(hideIsLoading());
      if (res.status === 200) {
        dispatch({
          type: actionType.GET_EMPLOYE_LIST_SUCCESS,
          payload: res.data,
          message: res.data.message
        });
    } else if (res.status === 206) {
      dispatch({
        type: actionType.GET_EMPLOYE_LIST_FAILURE,
        error: res.data.message
      })
    }
  }).catch(error => {
     dispatch(hideIsLoading());
     if(error.response.data.error == "invalid_token"){
       dispatch(refreshApiService(getEmployeList, ))
   }
     dispatch({
       type: actionType.GET_EMPLOYE_LIST_FAILURE,
       error: error
     });
   });
};
 

export const addEmploye = (token, payload, ) => dispatch => {
  toast.dismiss();

    dispatch(showIsLoading());
  dispatch(emailValidService("employee",payload.emailId,payload.mobileNo,payload))
    const config = {
      method: 'post',
      url: URL.admin.ADD_EMPLOYE,
      params:token,
      data : payload,
      headers: {
        'Content-Type': 'application/json',
        "Authorization": 'Basic ' + btoa('epaper-client:epaper-secret'),
      }
   };
    axios(config).then((res) => {
      dispatch(hideIsLoading());
        if (res.status === 200) {
          dispatch(getEmployeList(token.access_token));
          dispatch({
            type: actionType.ADD_EMPLOYE_SUCCESS,
            payload: res.data,
            message: res.data.message
          });
          toast.success(res.data.message);
      } else if (res.status === 206) {
        dispatch({
          type: actionType.ADD_EMPLOYE_FAILURE,
          error: res.data.message
        })
        toast.error(res.data.message)
      }
    }).catch(error => {
       dispatch(hideIsLoading());
       if(error.response.data.error == "invalid_token"){
        dispatch(refreshApiService(addEmploye,payload ))
     }
       dispatch({
         type: actionType.ADD_EMPLOYE_FAILURE,
         error: error
       });
       toast.error(error.response.data.message)
     });
  };
   

  export const editEmploye = (token, Payload, ) => dispatch => {
    toast.dismiss();

    dispatch(showIsLoading());
  
    const config = {
      method: 'put',
      url: URL.admin.EDIT_EMPLOYE,
      params:token,
      data : Payload,
      headers: {
        'Content-Type': 'application/json',
        "Authorization": 'Basic ' + btoa('epaper-client:epaper-secret'),
      }     };
    axios(config).then((res) => {
      dispatch(hideIsLoading());
        if (res.status === 200) {
          dispatch(getEmployeList(token.access_token));
          dispatch({
            type: actionType.EDIT_EMPLOYE_SUCCESS,
            message: res.data.message
          });
          toast.success(res.data.message);
      } else if (res.status === 206) {
        dispatch({
          type: actionType.EDIT_EMPLOYE_FAILURE,
          error: res.data.message
        })
        toast.error(res.data.message);
      }
    }).catch(error => {
       dispatch(hideIsLoading());
       if(error.response.data.error == "invalid_token"){
        dispatch(refreshApiService(editEmploye,Payload ))
     }
       dispatch({
         type: actionType.EDIT_EMPLOYE_FAILURE,
         error: error
       });
       toast.error(error.response.data.message)
     });
  };
   

  export const deleteEmploye = (token, id, ) => dispatch => {
    toast.dismiss();

    dispatch(showIsLoading());
  
    const config = {
      method: 'delete',
      url: URL.admin.DELETE_EMPLOYE + id ,
      headers: {
        'Content-Type' : "application/json",
         "Authorization": 'bearer  ' + token,
      }  
     };
    axios(config).then((res) => {
      dispatch(hideIsLoading());
        if (res.status === 200) {
          dispatch(getEmployeList(token));
          dispatch({
            type: actionType.DELETE_EMPLOYE_SUCCESS,
            payload: res.data,
            message: res.data.message
          });
          toast.success(res.data.message)
      } else if (res.status === 206) {
        dispatch({
          type: actionType.DELETE_EMPLOYE_FAILURE,
          error: res.data.message
        })
        toast.error(res.data.message);
      }
    }).catch(error => {
       dispatch(hideIsLoading());
       if(error.response.data.error == "invalid_token"){
        dispatch(refreshApiService(deleteEmploye,id ))
     }
       dispatch({
         type: actionType.DELETE_EMPLOYE_FAILURE,
         error: error
       });
       toast.error(error.response.data.message)
     });
  };
   


  export const getPaymentRules = token => dispatch => {
    toast.dismiss();

    dispatch(showIsLoading());
  
    const config = {
      method: 'get',
      url: URL.admin.GET_PAYMENT_RULES,
      headers: {
        'Content-Type' : "application/json",
         "Authorization": 'bearer  ' + token,
      }  
     };
    axios(config).then((res) => {
      dispatch(hideIsLoading());
        if (res.status === 200){
          dispatch({
            type: actionType.GET_PAYMENT_RULES_SUCCESS,
            payload: res.data,
            message: res.data.message
          });
      } else if (res.status === 206) {
        dispatch({
          type: actionType.GET_PAYMENT_RULES_FAILURE,
          error: res.data.message
        })
      }
    }).catch(error => {
       dispatch(hideIsLoading());
       if(error.response.data.error == "invalid_token"){
        dispatch(refreshApiService(getPaymentRules, ))
     }
       dispatch({
         type: actionType.GET_PAYMENT_RULES_FAILURE,
         error: error
       });
     });
  };
   
  export const editPaymentRule = (token, Payload, ) => dispatch => {
    toast.dismiss();

    dispatch(showIsLoading());
  
    const config = {
      method: 'put',
      url: URL.admin.EDIT_PAYMENT_RULE,
      headers: {
        'Content-Type' : "application/json",
         "Authorization": 'bearer  ' + token,
      },
      data : Payload
     };
    axios(config).then((res) => {
      dispatch(hideIsLoading());
        if (res.status === 200) {
          dispatch(getPaymentRules(token));
          dispatch({
            type: actionType.EDIT_PAYMENT_RULE_SUCCESS,
            message: res.data.message
          });
          toast.success(res.data.message)
      } else if (res.status === 206) {
        dispatch({
          type: actionType.EDIT_PAYMENT_RULE_FAILURE,
          error: res.data.message
        })
        toast.error(res.data.message)
      }
    }).catch(error => {
       dispatch(hideIsLoading());
       if(error.response.data.error == "invalid_token"){
        dispatch(refreshApiService(editPaymentRule, Payload))
     }
       dispatch({
         type: actionType.EDIT_PAYMENT_RULE_FAILURE,
         error: error
       });
       toast.error(error.response.data.message)
     });
  };


  export const getApproximateCost = token => dispatch => {
    toast.dismiss();

 
    dispatch(showIsLoading());
  
    const config = {
      method: 'get',
      url: URL.admin.GET_APPROXIMATE_COST,
      headers: {
        'Content-Type' : "application/json",
         "Authorization": 'bearer  ' + token,
      }  
     };
    axios(config).then((res) => {
      dispatch(hideIsLoading());
        if (res.status === 200) {

          dispatch({
            type: actionType.GET_APPROXIMATE_COST_SUCCESS,
            payload: res.data,
            message: res.data.message
          });
      } else if (res.status === 206) {
        dispatch({
          type: actionType.GET_APPROXIMATE_COST_FAILURE,
          error: res.data.message
        })
        toast.error(res.data.message)
      }
    }).catch(error => {
       dispatch(hideIsLoading());
       if(error.response.data.error == "invalid_token"){
        dispatch(refreshApiService(getApproximateCost,))
     }
       dispatch({
         type: actionType.GET_APPROXIMATE_COST_FAILURE,
         error: error
       });
        toast.error(error.response.data.message)
     });
  };


  export const updateApproximateCost = (token, payload, ) => dispatch => {
    toast.dismiss();

 
    dispatch(showIsLoading());
  
    const config = {
      method: 'post',
      url: URL.admin.UPDATE_APPROXIMATE_COST,
      data:payload,
      headers: {
        'Content-Type' : "application/json",
         "Authorization": 'bearer  ' + token,
      }  
     };
    axios(config).then((res) => {
      dispatch(hideIsLoading());
        if (res.status === 200) {
          dispatch(getApproximateCost(token));
          dispatch({
            type: actionType.UPDATE_APPROXIMATE_COST_SUCCESS,
            payload: res.data,
            message: res.data.message
          });
          toast.success(res.data.message)
      } else if (res.status === 206) {
        dispatch({
          type: actionType.UPDATE_APPROXIMATE_COST_FAILURE,
          error: res.data.message
        })
        toast.error(res.data.message)
      }
    }).catch(error => {
       dispatch(hideIsLoading());
       if(error.response.data.error == "invalid_token"){
        dispatch(refreshApiService(updateApproximateCost, payload))
     }
       dispatch({
         type: actionType.UPDATE_APPROXIMATE_COST_FAILURE,
         error: error
       });
      toast.error(error.response.data.message)
     });
  };



  export const getBestPerformanceList = (token,updateDate,updateDateEnd,status) => dispatch => {
    toast.dismiss();

    dispatch(showIsLoading());
  
    const config = {
      method: 'get',
      url: URL.admin.GET_BESTPERFORMANCE_LIST,
       params:{
      updateDate : updateDate,
      updateDateEnd : updateDateEnd,
      status : status
     },
      headers: {
        // 'Content-Type' : "application/json",
         "Authorization": 'bearer ' + token,
      }  
     };
    axios(config).then((res) => {
      dispatch(hideIsLoading());
        if (res.status === 200) {
          dispatch({
            type: actionType.GET_BESTPERFORMANCE_SUCCESS,
            payload: res.data,
            message: res.data.message
          });
      } else if (res.status === 206) {
        dispatch({
          type: actionType.GET_BESTPERFORMANCE_FAILURE,
          error: res.data.message
        })
      }
    }).catch(error => {
       dispatch(hideIsLoading());
       if(error.response.data.error == "invalid_token"){
        dispatch(refreshApiService(getBestPerformanceList, updateDate,updateDateEnd,status))
     }
       dispatch({
         type: actionType.GET_BESTPERFORMANCE_FAILURE,
         error: error
       });
     });
  };


  export const getRequestStatusList = (token, payload) => dispatch => {
    toast.dismiss();

    dispatch(showIsLoading());
  
    const config = {
      method: 'post',
      url: URL.admin.GET_REQUEST_STATUS_LIST,
      data:payload,
      headers: {
        'Content-Type' : "application/json",
         "Authorization": 'bearer  ' + token,
      }  
     };
    axios(config).then((res) => {
      dispatch(hideIsLoading());
        if (res.status === 200) {
          dispatch({
            type: actionType.GET_REQUEST_STATUS_LIST_SUCCESS,
            payload: res.data,
            message: res.data.message
          });
      } else if (res.status === 206) {
        dispatch({
          type: actionType.GET_REQUEST_STATUS_LIST_FAILURE,
          error: res.data.message
        })
      }
    }).catch(error => {
       dispatch(hideIsLoading());
       if(error.response.data.error == "invalid_token"){
        dispatch(refreshApiService(getRequestStatusList,payload))
     }
       dispatch({
         type: actionType.GET_REQUEST_STATUS_LIST_FAILURE,
         error: error
       });
     });
  };

  export const getMonthlyRequestList = (token) => dispatch => {
    toast.dismiss();

    dispatch(showIsLoading());
  
    const config = {
      method: 'get',
      url: URL.admin.GET_MONTHLY_REQUEST_LIST,
       headers: {
        'Content-Type' : "application/json",
         "Authorization": 'bearer  ' + token,
      }  
     };
    axios(config).then((res) => {
      dispatch(hideIsLoading());
        if (res.status === 200) {
          dispatch({
            type: actionType.GET_MONTHLY_REQUEST_LIST_SUCCESS,
            payload: res.data,
            message: res.data.message
          });
      } else if (res.status === 206) {
        dispatch({
          type: actionType.GET_MONTHLY_REQUEST_LIST_FAILURE,
          error: res.data.message
        })
      }
    }).catch(error => {
       dispatch(hideIsLoading());
       if(error.response.data.error == "invalid_token"){
        dispatch(refreshApiService(getMonthlyRequestList,))
     }
       dispatch({
         type: actionType.GET_MONTHLY_REQUEST_LIST_FAILURE,
         error: error
       });
     });
  };

  export const getRevenueReports = (token, payload, one, two) => dispatch => {
    toast.dismiss();

    dispatch(showIsLoading());
  
    const config = {
      method: 'post',
      url: URL.admin.REVENUE_REPORTS,
      data:payload,
      headers: {
        'Content-Type' : "application/json",
         "Authorization": 'bearer  ' + token,
      }  
     };
    axios(config).then((res) => {
      dispatch(hideIsLoading());
        if (res.status === 200) {
          dispatch(getEmployeList(token));
           dispatch(getFaxedPagesApi(token, payload));
          dispatch(getAverageReports(token, payload));
          dispatch(getFacilityReports(token, payload));
          dispatch(getCompletedReports(token, one));
          dispatch(getPractitionerReports(token, two));
          dispatch({
            type: actionType.REVENUE_REPORT_SUCCESS,
            payload: res.data,
            message: res.data.message
          });
      } else if (res.status === 206) {
        dispatch(getEmployeList(token));
        dispatch(getFaxedPagesApi(token, payload));
        dispatch(getAverageReports(token, payload));
        dispatch(getFacilityReports(token, payload));
        dispatch(getCompletedReports(token, one));
        dispatch(getPractitionerReports(token, two));
        dispatch({
          type: actionType.REVENUE_REPORT_FAILURE,
          error: res.data.message
        })
      }
    }).catch(error => {
       dispatch(hideIsLoading());
       if(error.response.data.error == "invalid_token"){
        dispatch(refreshApiService(getRevenueReports,payload, one, two))
     }
       dispatch({
         type: actionType.REVENUE_REPORT_FAILURE,
         error: error
       });
     });
  };


  export const getFaxedPagesApi = (token, payload) => dispatch => {
    toast.dismiss();

    dispatch(showIsLoading());
  
    const config = {
      method: 'post',
      url: URL.admin.FAXED_PAGES_API,
      data:payload,
      headers: {
        'Content-Type' : "application/json",
         "Authorization": 'bearer  ' + token,
      }  
     };
    axios(config).then((res) => {
      dispatch(hideIsLoading());
        if (res.status === 200) {
          dispatch({
            type: actionType.FAXEDPAGE_REPORT_SUCCESS,
            payload: res.data,
            message: res.data.message
          });
      } else if (res.status === 206) {
        dispatch({
          type: actionType.FAXEDPAGE_REPORT_FAILURE,
          error: res.data.message
        })
      }
    }).catch(error => {
       dispatch(hideIsLoading());
       if(error.response.data.error == "invalid_token"){
        dispatch(refreshApiService(getFaxedPagesApi,payload))
     }
       dispatch({
         type: actionType.FAXEDPAGE_REPORT_FAILURE,
         error: error
       });
     });
  };

  export const getAverageReports = (token, payload) => dispatch => {
    toast.dismiss();

    dispatch(showIsLoading());
  
    const config = {
      method: 'post',
      url: URL.admin.AVERAGE_REPORTS,
      data:payload,
      headers: {
        'Content-Type' : "application/json",
         "Authorization": 'bearer  ' + token,
      }  
     };
    axios(config).then((res) => {
      dispatch(hideIsLoading());
        if (res.status === 200) {
          dispatch({
            type: actionType.AVERAGE_REPORT_SUCCESS,
            payload: res.data,
            message: res.data.message
          });
      } else if (res.status === 206) {
        dispatch({
          type: actionType.AVERAGE_REPORT_FAILURE,
          error: res.data.message
        })
      }
    }).catch(error => {
       dispatch(hideIsLoading());
       if(error.response.data.error == "invalid_token"){
        dispatch(refreshApiService(getAverageReports,payload))
     }
       dispatch({
         type: actionType.AVERAGE_REPORT_FAILURE,
         error: error
       });
     });
  };
  export const getFacilityReports = (token, payload) => dispatch => {
    toast.dismiss();

    dispatch(showIsLoading());
  
    const config = {
      method: 'post',
      url: URL.admin.FACILITY_REPORTS,
      data:payload,
      headers: {
        'Content-Type' : "application/json",
         "Authorization": 'bearer  ' + token,
      }  
     };
    axios(config).then((res) => {
      dispatch(hideIsLoading());
        if (res.status === 200) {
          dispatch({
            type: actionType.FACILITY_REPORT_SUCCESS,
            payload: res.data,
            message: res.data.message
          });
      } else if (res.status === 206) {
        dispatch({
          type: actionType.FACILITY_REPORT_FAILURE,
          error: res.data.message
        })
      }
    }).catch(error => {
       dispatch(hideIsLoading());
       if(error.response.data.error == "invalid_token"){
        dispatch(refreshApiService(getFacilityReports,payload))
     }
       dispatch({
         type: actionType.FACILITY_REPORT_FAILURE,
         error: error
       });
     });
  };

  export const getCompletedReports = (token, payload) => dispatch => {
    toast.dismiss();

    dispatch(showIsLoading());
  
    const config = {
      method: 'post',
      url: URL.admin.COMPLETED_REPORTS,
      data:payload,
      headers: {
        'Content-Type' : "application/json",
         "Authorization": 'bearer  ' + token,
      }  
     };
    axios(config).then((res) => {
      dispatch(hideIsLoading());
        if (res.status === 200) {
          dispatch({
            type: actionType.COMPLETED_REPORT_SUCCESS,
            payload: res.data,
            message: res.data.message
          });
      } else if (res.status === 206) {
        dispatch({
          type: actionType.COMPLETED_REPORT_FAILURE,
          error: res.data.message
        })
      }
    }).catch(error => {
       dispatch(hideIsLoading());
       if(error.response.data.error == "invalid_token"){
        dispatch(refreshApiService(getCompletedReports,payload))
     }
       dispatch({
         type: actionType.COMPLETED_REPORT_FAILURE,
         error: error
       });
     });
  };
  export const getPractitionerReports = (token, payload) => dispatch => {
    toast.dismiss();

    dispatch(showIsLoading());
  
    const config = {
      method: 'post',
      url: URL.admin.PRACTITIONER_REPORTS,
      data:payload,
      headers: {
        'Content-Type' : "application/json",
         "Authorization": 'bearer  ' + token,
      }  
     };
    axios(config).then((res) => {
      dispatch(hideIsLoading());
        if (res.status === 200) {
          dispatch({
            type: actionType.PRACTITIONER_REPORT_SUCCESS,
            payload: res.data,
            message: res.data.message
          });
      } else if (res.status === 206) {
        dispatch({
          type: actionType.PRACTITIONER_REPORT_FAILURE,
          error: res.data.message
        })
      }
    }).catch(error => {
       dispatch(hideIsLoading());
       if(error.response.data.error == "invalid_token"){
        dispatch(refreshApiService(getPractitionerReports,payload))
     }
       dispatch({
         type: actionType.PRACTITIONER_REPORT_FAILURE,
         error: error
       });
     });
  };

  export const getHedisFlat = token => dispatch => {
    toast.dismiss();

 
    dispatch(showIsLoading());
  
    const config = {
      method: 'get',
      url: URL.admin.GET_HEDIS_FLAT,
      headers: {
        'Content-Type' : "application/json",
         "Authorization": 'bearer  ' + token,
      }  
     };
    axios(config).then((res) => {
      dispatch(hideIsLoading());
        if (res.status === 200) {

          dispatch({
            type: actionType.GET_HEDIS_FLAT_SUCCESS,
            payload: res.data,
            message: res.data.message
          });
      } else if (res.status === 206) {
        dispatch({
          type: actionType.GET_HEDIS_FLAT_FAILURE,
          error: res.data.message
        })
        toast.error(res.data.message)
      }
    }).catch(error => {
       dispatch(hideIsLoading());
       if(error.response.data.error == "invalid_token"){
        dispatch(refreshApiService(getHedisFlat,))
     }
       dispatch({
         type: actionType.GET_HEDIS_FLAT_FAILURE,
         error: error
       });
        toast.error(error.response.data.message)
     });
  };


  export const updateHedisFlat = (token, payload, ) => dispatch => {
    toast.dismiss();

 
    dispatch(showIsLoading());
  
    const config = {
      method: 'post',
      url: URL.admin.UPDATE_HEDIS_FLAT,
      data:payload,
      headers: {
        'Content-Type' : "application/json",
         "Authorization": 'bearer  ' + token,
      }  
     };
    axios(config).then((res) => {
      dispatch(hideIsLoading());
        if (res.status === 200) {
          dispatch(getApproximateCost(token));
          dispatch({
            type: actionType.UPDATE_HEDIS_FLAT_SUCCESS,
            payload: res.data,
            message: res.data.message
          });
          toast.success(res.data.message)
      } else if (res.status === 206) {
        dispatch({
          type: actionType.UPDATE_HEDIS_FLAT_FAILURE,
          error: res.data.message
        })
        toast.error(res.data.message)
      }
    }).catch(error => {
       dispatch(hideIsLoading());
       if(error.response.data.error == "invalid_token"){
        dispatch(refreshApiService(updateHedisFlat, payload))
     }
       dispatch({
         type: actionType.UPDATE_HEDIS_FLAT_FAILURE,
         error: error
       });
      toast.error(error.response.data.message)
     });
  };

  export const deleteUnprocessedRequest = (token, id,  userType, userId ) => dispatch => {
    toast.dismiss();

 
    dispatch(showIsLoading());
  
    const config = {
      method: 'delete',
      url: URL.admin.DELETE_UNPROCESSED_REQUEST + id,
      headers: {
        'Content-Type' : "application/json",
         "Authorization": 'bearer  ' + token,
      }  
     };
    axios(config).then((res) => {
      dispatch(hideIsLoading());
         if (res.status === 200) {
          dispatch(getRecordReqList(token,  userType, userId));
          dispatch({
            type: actionType.DELETE_UNPROCESSED_REQUEST_SUCCESS,
            payload: res.data,
            message: res.data.message
          });
          toast.success(res.data.message)
      } else if (res.status === 206) {
        dispatch({
          type: actionType.DELETE_UNPROCESSED_REQUEST_FAILURE,
          error: res.data.message
        })
        toast.error(res.data.message)
      }
    }).catch(error => {
       dispatch(hideIsLoading());
       if(error.response.data.error == "invalid_token"){
        dispatch(refreshApiService(deleteUnprocessedRequest, id,  userType, userId))
     }
       dispatch({
         type: actionType.DELETE_UNPROCESSED_REQUEST_FAILURE,
         error: error
       });
      toast.error(error.response.data.message)
     });
  };

  


  export const deletePracticeRequested = (token, id ) => dispatch => {
    toast.dismiss();

 
    dispatch(showIsLoading());
  
    const config = {
      method: 'delete',
      url: URL.admin.DELETE_REQUESTED_PRACTICE + id,
      headers: {
        'Content-Type' : "application/json",
         "Authorization": 'bearer  ' + token,
      }  
     };
    axios(config).then((res) => {
      dispatch(hideIsLoading());
         if (res.status === 200) {
          dispatch(getNewFacilityList(token));
          dispatch({
            type: actionType.DELETE_REQUESTED_PRACTICE_SUCCESS,
            payload: res.data,
            message: res.data.message
          });
          toast.success(res.data.message)
      } else if (res.status === 206) {
        dispatch({
          type: actionType.DELETE_REQUESTED_PRACTICE_FAILURE,
          error: res.data.message
        })
        toast.error(res.data.message)
      }
    }).catch(error => {
       dispatch(hideIsLoading());
       if(error.response.data.error == "invalid_token"){
        dispatch(refreshApiService(deletePracticeRequested, id))
     }
       dispatch({
         type: actionType.DELETE_REQUESTED_PRACTICE_FAILURE,
         error: error
       });
      toast.error(error.response.data.message)
     });
  };
  
  export const savePaymentRule = Payload => {
        return{
          type:actionType.SAVE_PAYMENT_RULE,
          payload: Payload
      }
  };



  